import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EnvironmentInjector,
    HostListener,
    inject,
    NgZone
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { TuiMobileDialogModule, TuiSheetDialogModule, TuiSheetModule } from '@taiga-ui/addon-mobile';
import { TuiAlertModule, TuiDialogModule, TuiRootModule } from '@taiga-ui/core';
import { ENVIRONMENT } from '@us/app-config';
import { NotificationsActions } from '@us/web/notifications/data-access';
import { isFnBApp } from '@us/web/shared/utils';

@UntilDestroy()
@Component({
    selector: 'us-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TuiRootModule,
        TuiAlertModule,
        TuiDialogModule,
        TuiSheetModule,
        TuiSheetDialogModule,
        TuiMobileDialogModule,
        IonicModule
    ]
})
export class AppComponent implements AfterViewInit {
    private readonly store = inject(Store);
    private readonly env = inject(ENVIRONMENT);
    public readonly environmentInjector = inject(EnvironmentInjector);
    private readonly ngZone = inject(NgZone);

    @HostListener('window:focus', ['$event'])
    onFocus(): void {
        this.ngZone.run(() => {
            this.store.dispatch(NotificationsActions.loadNotifications({}));
        });
    }

    ngAfterViewInit(): void {
        this.onFocus();

        console.log(
            '%c%s',
            'background-color: rgb(99 102 241); color: #fff; padding: 4px; font-size: 12px;',
            'Welcome to PosApp Order version ' + this.env.version
        );

        const className = isFnBApp(this.env) ? 'posapp-order-fnb' : 'posapp-order-retail';
        document.body.classList.add(className);
    }
}
